import { cn } from "@/lib/utils";

export default function PageHeader({ overline, title, desc, icon: Icon, color = "text-mlily-blue bg-blue-50" }) {
  return (
    <div className="flex items-start gap-4" data-testid="page-header">
      {Icon && (
        <div className={cn("w-12 h-12 rounded-xl flex items-center justify-center shrink-0", color)}>
          <Icon className="w-6 h-6" />
        </div>
      )}
      <div>
        {overline && <div className="text-xs uppercase tracking-[0.2em] font-bold text-mlily-blue">{overline}</div>}
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        {desc && <p className="text-slate-500 mt-1 max-w-2xl">{desc}</p>}
      </div>
    </div>
  );
}
